import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { useLanguage } from '../../../../contexts/LanguageContext';

// ==============================|| SIDEBAR DRAWER ||============================== //

// ✅ Clear
const Index = ({ clientLogout, mobileNav, setMobileNav, setIsBlur, setBurgerActive }) => {
	const { pathname } = useLocation();
	const [show, setShow] = useState('');
	const clientUser = useSelector((state) => state.main.client);
	const [isOpened, setIsOpened] = useState(true);
	const compRef = useRef(null);
	const { t } = useLanguage()

	useEffect(() => {
		setShow('');
	}, [pathname, isOpened]);

	useEffect(() => {
		if (window.innerWidth <= 1150 && isOpened) {
			setIsOpened(false);
		}
	}, []);


	const handleResize = () => {
		if (window.innerWidth <= 1150 && isOpened) {
			setIsOpened(false);
		} else if (window.innerWidth > 1150) {
			setIsOpened(true);
		}
	};

	useEffect(() => {
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const handleClickOutside = (event) => {
		if (compRef.current && !compRef.current.contains(event.target)) {
			setShow('');
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, []);

	return (
		<>
			{show && <div className="nav-opacity-bg">&nbsp;</div>}

			<div
				className={`new-nav-bar-client navbar-client-mobile ${isOpened || mobileNav ? 'expanded' : 'mobile-collapsed'}`}
				style={{ height: '100%' }}
			>
				<ul className="navbar-nav-items" ref={compRef}>
					<li className={`nav-item ${pathname.includes('/client/dashboard') ? 'active' : ''}`}>
						<Link
							to={'/client/dashboard'}
							className={`nav-link ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
							onClick={() => {
								setMobileNav(false);
								setIsBlur(false);
								setBurgerActive(false);
							}}
						>
							<span style={{ fontSize: 28 }}>Dashboard</span>
						</Link>
					</li>
					<li className={`nav-item ${pathname.includes('/client/quotations') ? 'active' : ''}`}>
						<Link
							to={'/client/quotations'}
							className={`nav-link ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
							onClick={() => {
								setMobileNav(false);
								setIsBlur(false);
								setBurgerActive(false);
							}}
						>
							<span style={{ fontSize: 28 }}>{t('nav.quotations')}</span>
						</Link>
					</li>
					<li className={`nav-item ${pathname.includes('/client/sales-orders') ? 'active' : ''}`}>
						<Link
							to={'/client/sales-orders'}
							className={`nav-link ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
							onClick={() => {
								setMobileNav(false);
								setIsBlur(false);
								setBurgerActive(false);
							}}
						>
							<span style={{ fontSize: 28 }}>Sales Orders</span>
						</Link>
					</li>
					<li className={`nav-item ${pathname.includes('/client/invoices') ? 'active' : ''}`}>
						<Link
							to={'/client/invoices'}
							className={`nav-link ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
							onClick={() => {
								setMobileNav(false);
								setIsBlur(false);
								setBurgerActive(false);
							}}
						>
							<span style={{ fontSize: 28 }}>{t('nav.invoices')}</span>
						</Link>
					</li>

					<li className={`nav-item ${pathname.includes('/client/serials') ? 'active' : ''}`}>
						<Link
							to={'/client/serials'}
							className={`nav-link ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
							onClick={() => {
								setMobileNav(false);
								setIsBlur(false);
								setBurgerActive(false);
							}}
						>
							<span style={{ fontSize: 28 }}>{t('nav.serials')}</span>
						</Link>
					</li>

					<li className={`nav-item ${pathname.includes('/client/shipments') ? 'active' : ''}`}>
						<Link
							to={'/client/shipments'}
							className={`nav-link ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
							onClick={() => {
								setMobileNav(false);
								setIsBlur(false);
								setBurgerActive(false);
							}}
						>
							<span style={{ fontSize: 28 }}>{t('nav.shipments')}</span>
						</Link>
					</li>

					{clientUser?.data?.is_approved != 2 && (
						<li className={`nav-item company-details-link ${pathname.includes('/client') ? 'active' : ''}`}>
							<Link
								to={'/client/company-details'}
								className={`nav-link `}
								onClick={() => {
									setMobileNav(false);
									setIsBlur(false);
									setBurgerActive(false);
								}}
							>
								{isOpened ? (
									<div className={` cmpny-dtls ${clientUser?.data?.is_approved === 2 ? 'cmpny-dtls-vrfied' : ''}`}>
										<span>Company Info</span>

										{clientUser?.data?.is_approved != 2 && (
											<span className="action-required">
												{' '}
												{clientUser?.data?.is_approved === 0
													? 'Action needed'
													: clientUser?.data?.is_approved === 1
													? 'waiting for approval'
													: 'Approved'}
											</span>
										)}
									</div>
								) : (
									<span style={{ fontSize: 28 }}>Company Info</span>
								)}
							</Link>
						</li>
					)}
				</ul>
			</div>
		</>
	);
};

export default Index;
